module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "viewBox": _vm.viewBox,
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke-width": _vm.strokeWidth
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-08c77eb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CircleProgress.vue
// module id = 195
// module chunks = 1